<template>
  <div class="team-member content-bg">
    <div
      class="member-image"
      v-if="itemImage(member)"
      :style="{backgroundImage: `url('${itemImage(member)}')`}"
    ></div>

    <div class="member-info" :class="{'bio-active': bioActive}">
      <div class="personal-details">
        <h3 v-if="parse(member).name" @click="highlightField('name')">{{ parse(member).name }}</h3>
        <h3 class="job-role" v-if="parse(member).job_role" @click="highlightField('job role')">{{ parse(member).job_role }}</h3>

        <p v-if="parse(member).email_address" @click="highlightField('email address')">
          <a :title="`Link will email ${parse(member).email_address}`">{{
            parse(member).email_address
          }}</a>
        </p>

        <p v-if="parse(member).phone_number" @click="highlightField('phone number')">
          <a :title="`Link will call ${parse(member).phone_number}`">{{ parse(member).phone_number }}</a>
        </p>
      </div>

      <div class="member-bio">
        <div class="bio-inner">
          <div v-html="parse(member).bio" @click="highlightField('bio')"></div>
        </div>
      </div>

      <div class="social-links">
        <div
          v-for="platform in availablePlatforms"
          :key="`platform-${platform.platform}`"
          @click="highlightField(`${platform.platform} username`)"
        >
          <SocialLink
            v-if="parse(member)[platform.field]"
            :platform="getPlatform(platform.platform, platform.field)"
            :label="false"
          />
        </div>

        <button
          class="btn is-dark close-bio"
          v-if="parse(member).bio && bioActive"
          @click="toggleBio"
        >
          <Sprite name="close" />
        </button>
      </div>

      <button class="btn open-bio" v-if="parse(member).bio" @click="toggleBio">
        Read Bio
      </button>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

import SocialLink from '@/components/SocialLink'
import Sprite from '@/components/Sprite'

export default {
  name: 'TeamMember',

  mixins: [parseComponent],

  props: {
    member: Object,
    demoMode: Boolean
  },

  data() {
    return {
      bioActive: false,
      availablePlatforms: [
        {platform: 'facebook', field: 'facebook_username'},
        {platform: 'instagram', field: 'instagram_username'},
        {platform: 'twitter', field: 'twitter_username'},
        {platform: 'youtube', field: 'youtube_username'},
        {platform: 'snapchat', field: 'snapchat_username'},
        {platform: 'pinterest', field: 'pinterest_username'},
        {platform: 'linkedin', field: 'linkedin_username'}
      ]
    }
  },

  components: {
    SocialLink,
    Sprite
  },

  computed: {
    itemImage() {
      return (item) => {
        return this.demoMode ? this.parse(item).image_url : item.image_versions[0].url
      }
    },

    getPlatform() {
      return (platform, field) => {
        return {key: platform, value: this.parse(this.member)[field]}
      }
    }
  },

  methods: {
    toggleBio() {
      this.bioActive = !this.bioActive
    }
  }
}
</script>

<style lang="sass">
@import '../../../stylesheets/base/variables'
@import '../../../stylesheets/helpers/mixins'

.team-member
  margin: $gap-small
  padding: 0!important
  position: relative
  overflow: hidden

  @include media($media-gt-small)
    flex-basis: percentage(1/4)
    display: flex
    align-items: stretch
    flex-direction: column

  .member-image
    width: 100%
    height: 200px
    background-size: cover
    background-position: 50% 50%

  .member-info
    display: flex
    flex-direction: column
    width: 100%
    flex-grow: 1
    justify-content: space-between
    padding: $gap-small

    &.bio-active
      .member-bio
        opacity: 1
        z-index: 2
        transition: opacity .3s .1s ease-in-out, z-index .1s ease-in-out

    h3
      margin: 0

    p
      font-size: 12px
      margin: 5px 0

    .personal-details
      text-align: center

      a
        color: #404040
        cursor: pointer

  .job-role
    font-size: 12px

  .member-bio
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    opacity: 0
    z-index: -100
    transition: opacity .3s ease-in-out, z-index .3s .3s ease-in-out
    background: #fff

    .bio-inner
      height: 100%
      padding: 50px $gap-small $gap-small
      overflow: auto
      -webkit-overflow-scrolling: touch

  .social-links
    display: flex
    align-items: center
    justify-content: center
    flex-wrap: wrap
    margin: $gap-small 0

    .social-link
      pointer-events: none
      opacity: 0.75
      transition: opacity .2s ease-in-out

      &:hover
        opacity: 1

  .sprite
    width: 20px
    height: 20px
    margin: 0 $gap-small
    fill: #404040

.btn
  &.open-bio
    margin-top: $gap-small
    padding: 10px 20px!important
    background: #404040

  &.close-bio
    position: absolute
    top: $gap-small
    right: $gap-small
    padding: 5px 5px 1px 5px
    border-radius: 50%
    z-index: 2
    opacity: 0.25

    &:hover
      opacity: 1

    .sprite
      width: 15px
      height: 15px
      margin: 1px 1px 5px 1px
      fill: #fff
</style>
